import { render } from "./ListaIncidencias.vue?vue&type=template&id=fa7979ba&scoped=true"
import script from "./ListaIncidencias.vue?vue&type=script&lang=js"
export * from "./ListaIncidencias.vue?vue&type=script&lang=js"

import "./ListaIncidencias.vue?vue&type=style&index=0&id=fa7979ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7979ba"]])

export default __exports__